import * as React from "react";
import withDARApp from "@lululemon/ecom-site/src/with-app";
import NotFoundContainer from "../src/containers/not-found/not-found";

const NotFoundPage = ({ pageData = {} }) => {
  return <NotFoundContainer pageData={pageData} />;
};

export default withDARApp(NotFoundPage);
